import { roleGuard } from '@/core/guards/role.guard';
import { sessionGuard } from '@/core/guards/session.guard';
import { Routes } from '@angular/router';
import { AuthGuard } from '@auth0/auth0-angular';

export const mainRoutes: Routes = [
    {
        path: 'payments',
        loadComponent: () =>
          import('./components/payments/payments.component').then(
            m => m.PaymentsComponent
          ),
        canActivate: [AuthGuard, roleGuard, sessionGuard]
      },
      {
        path: 'simulations',
        loadComponent: () =>
          import('./components/simulations/simulations.component').then(
            m => m.SimulationsComponent
          ),
        canActivate: [AuthGuard, roleGuard, sessionGuard]
      },
      {
        path: 'credits',
        loadComponent: () =>
          import('./components/credits/credits.component').then(
            m => m.CreditsComponent
          ),
        canActivate: [AuthGuard, roleGuard, sessionGuard]
      },
      {
        path: 'inversors',
        loadComponent: () =>
          import('./components/inversors/inversors.component').then(
            m => m.InversorsComponent
          ),
        canActivate: [AuthGuard, roleGuard, sessionGuard]
      },
      {
        path: 'beneficiaries',
        loadComponent: () =>
          import('./components/beneficiaries/beneficiaries.component').then(
            m => m.BeneficiariesComponent
          ),
        canActivate: [AuthGuard, roleGuard, sessionGuard]
      },
      {
        path: 'groups',
        loadComponent: () =>
          import('./components/groups/groups.component').then(
            m => m.GroupsComponent
          ),
        canActivate: [AuthGuard, roleGuard, sessionGuard]
      }
];
